import { doFetch } from "./fetch"

class Distrcits {
  getDistricts() {
    return doFetch(`/api/districts`)
  }
}
export const districtsApi = new Distrcits()
